// DESCRIPTION: Registers the Nemtly Events query loop variation with custom controls
// for event type filtering and hiding past events.

/**
 * WordPress dependencies
 */
import { registerBlockVariation } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';

registerBlockVariation( 'core/query', {
	name: 'nemtly/events',
	title: __( 'Nemtly Events', 'nemtly-booking' ),
	category: "nemtly-blocks",
	description: __(
		'Display a list of upcoming events.',
		'nemtly-booking'
	),
	icon: 'calendar-alt',
	attributes: {
		namespace: 'nemtly/events',
		query: {
			postType: 'nemtly_event',
			perPage: 6,
			offset: 0,
			order: 'asc',
			orderBy: 'date',
			inherit: false,
		},
		displayLayout: {
			type: 'flex',
			columns: 3,
		},
	},
	allowedControls: [ 'order', 'search' ],
	innerBlocks: [
		[
			'core/post-template',
			{},
			[
				[
					'core/post-featured-image',
					{ isLink: true, height: '200px' },
				],
				[ 'nemtly/event-date', { showTime: true, showIcon: true } ],
				[ 'core/post-title', { isLink: true, level: 3 } ],
				[ 'core/post-excerpt' ],
				[ 'nemtly/price' ],
			],
		],
		[ 'core/query-pagination' ],
		[ 'core/query-no-results' ],
	],
	scope: [ 'inserter' ],
	isActive: [ 'namespace' ],
} );
